module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new/_next/static/images/placecard-8f1325ce2e35fdef1299203f6ad75d7a.jpeg";